export { default } from './product-info';
